import ShortCutSwitch from './ShortCutSwitch';
export default ShortCutSwitch;
